import { Navigate, useParams } from 'react-router-dom';
import { InvoicesPage } from './InvoicesByClientYardComponents';
import {
  InvoicesViewHeader,
  InvoicesViewLinesTable,
  InvoicesViewSubHeader,
} from './InvoicesViewComponents';
import { InvoicePrint } from './InvoicePrint';
import { useInvoiceQuery } from '../../hooks';

export const InvoicesView = () => {
  const params: any = useParams();
  const { data: invoice, isFetching } = useInvoiceQuery(params.id);

  if (isFetching) return <></>;
  if (!invoice?.id) return <Navigate to={'/dashboard/invoices'} replace />;

  return (
    <>
      <InvoicesPage innerScroll gridTemplateRows="max-content max-content 1fr">
        <InvoicesViewHeader invoice={invoice} />
        <InvoicesViewSubHeader invoice={invoice} />
        <InvoicesViewLinesTable invoice={invoice} />
      </InvoicesPage>
      <InvoicePrint invoice={invoice} />
    </>
  );
};
